import React from 'react';
import './servicesSchedule.css';
import { useDispatch, useSelector } from "react-redux";
import { setServicesFormAction } from "../../redux/rootReducer";
import { GetReserveByIdThunk } from "../../redux/thunks/GetReserveByIdThunk";

const ServicesSchedule = () => {
    const dispatch = useDispatch();
    const services = useSelector(state => state.services);
    const services_form = useSelector(state => state.services_form);

    if (services.masters_schedules.length === 0) {
        return (
            <div className="page__content">
                <div className="empty__list">Нет расписания на указанную дату</div>
            </div>
        );
    }

    return (
        <div className="schedule">
            <div className={ `edit_mode ${ services_form.edit_mode ? 'edit_mode--active' : '' }`}>
                <div className="edit_mode__text">Редактирование записи. Укажите новые данные.</div>
            </div>
            <div className="schedule__masters">
                <div className="schedule__master"/>
                {
                    services.masters_schedules.map(elem => (
                        <div className="schedule__master" key={ elem.master_id }>{ elem.master_name }</div>
                    ))
                }
            </div>
            <div className="schedule__times">
                <div className="schedule__items">
                    {
                        services.schedule.map(elem => (
                            <div className="schedule__item schedule__item--align" key={ elem.time }>{ elem.time }</div>
                        ))
                    }
                </div>
                {
                    services.masters_schedules.map((elem, index) => (
                        <div className="schedule__items" key={ elem.master_id }>
                            {
                                elem.schedule.map(el => (
                                    <div
                                        key={ el.time }
                                        className={ `schedule__item ${ !el.active ? 'schedule__item--inactive' : '' } ${ services.date === services_form.date && el.time === services_form.time && index + 1 === services_form.master.id ? 'schedule__item--active' : '' }` }
                                        onClick={ () => {
                                            if (services_form.edit_mode) {
                                                dispatch(setServicesFormAction({
                                                    ...services_form,
                                                    master: {
                                                        id: services.masters_schedules[index].master_id,
                                                        name: services.masters_schedules[index].master_name
                                                    },
                                                    date: services.date,
                                                    time: el.time
                                                }));
                                            }
                                            else {
                                                // Открываем форму записи на услуги
                                                dispatch(setServicesFormAction({
                                                    ...services_form,
                                                    open: true,
                                                    id: 0,
                                                    master: {
                                                        id: services.masters_schedules[index].master_id,
                                                        name: services.masters_schedules[index].master_name
                                                    },
                                                    date: services.date,
                                                    time: el.time,
                                                    services: []
                                                }));
                                            }
                                        } }
                                    >
                                        {
                                            el.reserve &&
                                            <div className="schedule__reserve"
                                                style={{ height: el.reserve.height }}
                                                onClick={ (event) => {
                                                    // Запрашиваем данные записи по id
                                                    event.preventDefault();
                                                    event.stopPropagation();

                                                    dispatch(GetReserveByIdThunk({
                                                        reserve_id: el.reserve.id
                                                    }));
                                                } }
                                            >{ el.reserve.service.map((service, index) => (
                                                <div key={ index }>{ `${ index + 1 }. ${ service }` }</div>
                                            )) }</div>
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default ServicesSchedule;